<template>
  <index :status="1"></index>
</template>

<script>
import Index from "@/components/programs/Index.vue";
export default {
	components: {
    Index,
	},
};
</script>
